module.exports = __webpack_public_path__ + "ca449ead472f1bed4103c2d9fd37ad02.gltf";